import React from "react";
// import DATA from "./Data";
// import MaterialTable from "material-table";
import { withSnackbar } from "notistack";

class FeedbackTablePage extends React.Component {
  render() {
    return (
      <div>Feedback</div>
    );
  }
}
export default withSnackbar(FeedbackTablePage);
